import './explore_meals.css'

import React, { useState, useEffect } from 'react';
import { FaPlus, FaFilter } from "react-icons/fa6";
import { FaSortAmountUp } from "react-icons/fa";
import { get } from '../../Services/api';
import { useAuth } from '../../Components/AuthContext/AuthContext'
import MealCard from '../../Components/MealCard/MealCard';
import BeanButtonPrev from '../../Components/Buttons/BeanButton/BeanButtonPrev/BeanButtonPrev';
import BeanButtonNext from '../../Components/Buttons/BeanButton/BeanButtonNext/BeanButtonNext';
import CreateMealModal from '../../Components/CreateMeal/CreateMeal';
import { TextField, Radio, RadioGroup, InputLabel, MenuItem, Select, FormControlLabel, FormControl } from '@mui/material';
import CreateSnackModal from '../../Components/CreateSnack/CreateSnack';

function ExploreMeals() {

    const { currentUser } = useAuth();
    const [selectedPremadeList, setSelectedPremadeList] = useState('see_all')
    const [allMeals, setAllMeals] = useState([]);
    const [tredningMeals, setTredningMeals] = useState([]);
    const [favoriteMeals, setFavoriteMeals] = useState([]);
    const [pickedForYouMeals, setPickedForYouMeals] = useState([]);
    const [mealsToShow, setMealsToShow] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [total_pages, set_total_pages] = useState(1);
    const [noResults, setNoResults] = useState(false);
    const [query, setQuery] = useState('');
    const [allCourses, setAllCourses] = useState([])
    const [allCuisines, setAllCuisines] = useState([])

    const [showFilter, setShowFilter] = useState(false);
    const [showSort, setShowSort] = useState(false);
    const [showCreateMeal, setShowCreateMeal] = useState(false);
    const [sortDisabled, setSortDisabled] = useState(false);

    const [showAddMeal, setShowAddMeal] = useState(false);
    const [showAddSnack, setShowAddSnack] = useState(false);

    const [selectedSort, setSelectedSort] = useState('default');
    const [selected_cuisine, setSelectedCuisines] = useState('')
    const [selected_course, setSelectedCourse] = useState('')
    const [selected_cal, setSelectedCal] = useState(['', ''])
    const [selected_carb, setSelectedCarb] = useState(['', ''])
    const [selected_prot, setSelectedProt] = useState(['', ''])
    const [selected_fat, setSelectedFat] = useState(['', ''])
    const [selected_cost, setSelectedCost] = useState(['', ''])

    const sort = {
        Default: 'default',
        CaloriesLow: 'cal_low',
        CaloriesHigh: 'cal_high',
        CostLow: 'cost_low',
        CostHigh: 'cost_high',
    };

    // The object that holds all the values, including cuisine and course
    const [stateObject, setStateObject] = useState({
        calories: { min: '', max: '' },
        carbs: { min: '', max: '' },
        protein: { min: '', max: '' },
        fat: { min: '', max: '' },
        cost: { min: '', max: '' },
        cuisine: '',
        course: '',
    });

    // Function to update the object based on current state values
    const updateObjectFromState = () => {
        setStateObject({
            calories: { min: selected_cal[0], max: selected_cal[1] },
            carbs: { min: selected_carb[0], max: selected_carb[1] },
            protein: { min: selected_prot[0], max: selected_prot[1] },
            fat: { min: selected_fat[0], max: selected_fat[1] },
            cost: { min: selected_cost[0], max: selected_cost[1] },
            cuisine: selected_cuisine,  // Update cuisine
            course: selected_course,    // Update course
        });
    };

    // Function to update state based on the given object
    const updateStateFromObject = (obj) => {
        setSelectedCal([obj.calories.min, obj.calories.max]);
        setSelectedCarb([obj.carbs.min, obj.carbs.max]);
        setSelectedProt([obj.protein.min, obj.protein.max]);
        setSelectedFat([obj.fat.min, obj.fat.max]);
        setSelectedCost([obj.cost.min, obj.cost.max]);
        setSelectedCuisines(obj.cuisine);   // Update cuisine
        setSelectedCourse(obj.course);      // Update course
    };


    const numberFieldSX = {
        '& .MuiInputLabel-root': {
            color: 'gray',
            '&.Mui-focused': {
                color: '#1F2933',
            },
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#82BD9C', // Default border color
            },
            '&:hover fieldset': {
                borderColor: '#299257', // Border color on hover
            },
            '&.Mui-focused fieldset': {
                borderColor: '#299257', // Border color when focused
            },
        },

    }

    const selectSX = {
        // Default color
        '& .MuiSelect-select': {
            color: '#1F2933',
        },
        // Color when focused
        '&.Mui-focused .MuiSelect-select': {
            color: '#1F2933',
        },
        // Arrow color
        '& .MuiSelect-icon': {
            color: '#299257',
        },
        // Border color when focused
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#299257',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#299257',
        },
    }



    useEffect(() => {
        fetchResults()
    }, [stateObject]);


    useEffect(() => {
        fetchAllMeals()
    }, [pageNum]);

    useEffect(() => {
        if (query) {
            setSortDisabled(true)
            setPageNum(1)
            setSelectedPremadeList('see_all')
            // Add debouncing to reduce API calls
            const timerId = setTimeout(() => {
                fetchSearchResults(query);
            }, 500);  // Adjust debounce delay as needed
            return () => clearTimeout(timerId);  // Cleanup function for useEffect
        } else {
            setSortDisabled(false)
            setMealsToShow(allMeals)
            setNoResults(false)
        }
    }, [query]);

    function premadeGroupChanged(meals1) {
        let meals = meals1
        switch (Number(selectedSort)) {
            case 1:
                meals = meals1.sort((a, b) => a.total_calories - b.total_calories)
                break;
            case 2:
                meals = meals1.sort((a, b) => b.total_calories - a.total_calories)
                break;
            case 3:
                meals = meals1.sort((a, b) => a.cost - b.cost)
                break;
            case 4:
                meals = meals1.sort((a, b) => b.cost - a.cost)
                break;
        }
        setMealsToShow(meals)
    }

    function sortChanged(index) {
        let si = index != null ? index : selectedSort
        if (selectedPremadeList === 'see_all') {
            fetchAllMeals(si)
        } else {
            let meals = mealsToShow

            switch (Number(si)) {
                case 1:
                    meals = mealsToShow.sort((a, b) => a.total_calories - b.total_calories)
                    break;
                case 2:
                    meals = mealsToShow.sort((a, b) => b.total_calories - a.total_calories)
                    break;
                case 3:
                    meals = mealsToShow.sort((a, b) => a.cost - b.cost)
                    break;
                case 4:
                    meals = mealsToShow.sort((a, b) => b.cost - a.cost)
                    break;
            }
            setMealsToShow(meals)
        }
    }

    // Function to fetch search results from the server
    const fetchSearchResults = async (searchTerm) => {
        try {
            const result = await get("/api/meal/search-meal", { name: searchTerm, user_id: currentUser.uid });
            if (result != false) {
                // setMealsToShow(result);
                premadeGroupChanged(result)
                setNoResults(false)

            } else {
                setNoResults(true)
            }
        } catch (error) {
            console.error('Error fetching search results:', error);
        }
    };




    // Function to fetch search results from the server
    const fetchAllMeals = async (sort_method) => {
        try {
            const all_meals = await get('api/meal/get-all-meals-for-page', {
                user_id: currentUser.uid,
                page_size: 24,
                page_num: pageNum,
                filters: stateObject,
                sort_method: sort_method
            })

            setMealsToShow(all_meals)
            set_total_pages(all_meals[0].total_pages)
            setAllMeals(all_meals)

        } catch (error) {
            console.error('Error fetching search results:', error);
        }
    };

    // Function to fetch search results from the server
    const fetchResults = async () => {
        try {
            // All cuisines
            let result_cu = await get("/api/meal/get-all-cuisines")
            setAllCuisines(result_cu)


            // All courses
            const result_co = await get("/api/meal/get-all-courses")
            setAllCourses(result_co)

            const all_meals = await get('api/meal/get-all-meals-for-page', {
                user_id: currentUser.uid,
                page_size: 24,
                page_num: pageNum,
                filters: stateObject,
                sort_method: selectedSort
            })

            const trending_result = await get('api/meal/get-trending-meals', {
                user_id: currentUser.uid,
                count: 24
            })

            const favorite_result = await get('api/meal/get-favorite-meals', {
                user_id: currentUser.uid,
                count: 24
            })

            const pfu = await get('api/meal/get-picked-for-you-meals', {
                user_id: currentUser.uid,
                count: 24
            })

            setMealsToShow(all_meals)
            set_total_pages(all_meals[0].total_pages)
            setAllMeals(all_meals)
            setPickedForYouMeals(pfu);
            setFavoriteMeals(favorite_result);
            setTredningMeals(trending_result);
        } catch (error) {
            console.error('Error fetching search results:', error);
        }
    };

    function updateNumberFields(array, setArray, newValue, index) {
        const updatedArray = [...array];
        if (newValue === '' || Number(newValue) < 0) {
            updatedArray[index] = '';

        } else if (Number(newValue) >= 0) {
            updatedArray[index] = Number(newValue);
        }

        setArray(updatedArray);
    }

    return (
        <div >
            {
                showAddSnack && <CreateSnackModal currentUser={currentUser} modalOpen={showAddSnack} setModalOpen={setShowAddSnack} />
            }
            {
                showAddMeal && <CreateMealModal currentUser={currentUser} modalOpen={showAddMeal} setModalOpen={setShowAddMeal} />
            }
            <div className='explore_meals_header'>
                <p className='gray_scale_6 font_family_ovo font_size_40 font_weight_400 '>Explore All Meals</p>
                <div className='explore_meals_header_right'>
                    <span className='explore_meals_header_right_sort_filter'>
                        <div className='explore_meals_header_right_button font_family_inter font_weight_500 gray_scale_2'
                            onClick={() => {
                                setShowFilter(!showFilter)
                                setShowSort(false);
                                setShowCreateMeal(false)
                                updateStateFromObject(stateObject)
                            }}
                        >
                            <FaFilter color='5A5855' size={15} />
                            <p className='gray_scale_2 font_size_12'>
                                Filter
                            </p>
                        </div>
                        <div className='explore_meals_header_right_button font_family_inter font_weight_500'

                            onClick={() => {
                                if (!sortDisabled) {
                                    setShowSort(!showSort);
                                    setShowCreateMeal(false)
                                    setShowFilter(false)
                                }

                            }}
                        >
                            <FaSortAmountUp color='5A5855' size={15} />
                            <p className='gray_scale_2 font_size_12'>
                                Sort
                            </p>
                        </div>
                    </span>



                    <div className="explore_meals_add_meal_button cursor_pointer green_gradient gap_12 align_center"
                        onClick={() => {
                            setShowCreateMeal(!showCreateMeal)
                            setShowFilter(false)
                            setShowSort(false)
                        }}
                    >
                        <FaPlus color="white" size={15} />
                        <p className="white font_weight_600">Create Entry</p>
                    </div>

                </div>

            </div>

            {
                showCreateMeal && <div className='explore_meals_new_entry_parent'>
                    <p className='font_family_ovo font_size_24'>
                        Create Entry
                    </p>



                    <div className="explore_meals_add_meal_button cursor_pointer green_gradient gap_12 align_center justify_center"
                        onClick={() => {
                            setShowCreateMeal(false)
                            setShowAddMeal(true)
                        }}
                    >
                        {/* <FaPlus color="white" size={15} /> */}
                        <p className="white font_weight_600">New Meal</p>
                    </div>
                    <div className="explore_meals_add_meal_button cursor_pointer green_gradient gap_12 align_center justify_center"
                        onClick={() => {
                            setShowCreateMeal(false)
                            setShowAddSnack(true)
                        }}
                    >
                        {/* <FaPlus color="white" size={15} /> */}
                        <p className="white font_weight_600">New Snack</p>
                    </div>
                    <hr />
                    <div className='font_family_inter font_size_14 font_weight_600 white explore_meals_filter_apply_button green_orange_gradient'
                        onClick={() => {
                            setShowCreateMeal(false)
                        }}>
                        Cancel
                    </div>
                </div>
            }

            {showSort && <div className='explore_meals_sort_parent'>
                <p className='font_family_ovo font_size_24'>
                    Sort
                </p>

                <FormControl>
                    {/* <FormLabel id="demo-controlled-radio-buttons-group">{questions[currentQuestionIndex].}</FormLabel> */}
                    <RadioGroup
                        aria-labelledby="demo-controlled-radio-buttons-group"
                        name="controlled-radio-buttons-group"
                        value={selectedSort}
                        onChange={(e) => {
                            setSelectedSort(e.target.value)
                            sortChanged(e.target.value)
                            // setTimeout(() => {
                            setShowSort(false)
                            // }, 110);
                        }}
                    >
                        <div>
                            <FormControlLabel value={sort.Default} control={
                                <Radio
                                    sx={{
                                        color: '#82BD9C', // When not selected
                                        '&.Mui-checked': {
                                            color: '#299257', // When selected
                                        },
                                    }}

                                />
                            } label={'Default'} />
                            <FormControlLabel value={sort.CaloriesLow} control={
                                <Radio
                                    sx={{
                                        color: '#82BD9C', // When not selected
                                        '&.Mui-checked': {
                                            color: '#299257', // When selected
                                        },
                                    }}

                                />
                            } label={'Calories Low'} />

                            <FormControlLabel value={sort.CaloriesHigh} control={
                                <Radio
                                    sx={{
                                        color: '#82BD9C', // When not selected
                                        '&.Mui-checked': {
                                            color: '#299257', // When selected
                                        },
                                    }}

                                />
                            } label={'Calories High'} />
                            <FormControlLabel value={sort.CostLow} control={
                                <Radio
                                    sx={{
                                        color: '#82BD9C', // When not selected
                                        '&.Mui-checked': {
                                            color: '#299257', // When selected
                                        },
                                    }}

                                />
                            } label={'Cost Low'} />
                            <FormControlLabel value={sort.CostHigh} control={
                                <Radio
                                    sx={{
                                        color: '#82BD9C', // When not selected
                                        '&.Mui-checked': {
                                            color: '#299257', // When selected
                                        },
                                    }}

                                />
                            } label={'Cost High'} />

                        </div>

                    </RadioGroup>
                </FormControl>
                <div className='font_family_inter font_size_14 font_weight_600 white explore_meals_filter_apply_button green_orange_gradient'
                    onClick={() => {
                        setShowSort(false)
                    }}>
                    Cancel
                </div>
            </div>
            }

            {
                showFilter &&
                <div className='explore_meals_filter_parent'>
                    <p className='font_family_ovo font_size_24'>
                        Filters
                    </p>
                    <hr style={{ width: '100%' }} />
                    {/* Calories */}

                    <div className='explore_meals_filter_sections'>

                        <p className='font_family_inter font_size_16 gray_scale_2'>
                            Calories
                        </p>
                        <div className='explore_meals_numbers'>

                            <TextField
                                className='explore_meals_filter_number'

                                label={'Min calories'}
                                type="number"
                                value={selected_cal[0]}
                                onChange={
                                    (e) => {
                                        updateNumberFields(selected_cal, setSelectedCal, e.target.value, 0)

                                    }
                                }
                                // inputProps={{ min: 0 }}
                                margin="none"
                                sx={numberFieldSX}
                            />
                            -
                            <TextField
                                className='explore_meals_filter_number'

                                label={'Max calories'}
                                type="number"
                                value={selected_cal[1]}
                                onChange={
                                    (e) => {
                                        updateNumberFields(selected_cal, setSelectedCal, e.target.value, 1)
                                    }
                                }
                                margin="none"
                                sx={numberFieldSX}
                            />
                        </div>
                    </div>
                    {/* Protein */}

                    <div className='explore_meals_filter_sections'>

                        <p className='font_family_inter font_size_16 gray_scale_2'>
                            Protein
                        </p>
                        <div className='explore_meals_numbers'>
                            <TextField
                                className='explore_meals_filter_number'

                                label={'Min protein'}
                                type="number"
                                value={selected_prot[0]}
                                onChange={
                                    (e) => {
                                        updateNumberFields(selected_prot, setSelectedProt, e.target.value, 0)
                                    }
                                }
                                margin="none"
                                sx={numberFieldSX}
                            />
                            -
                            <TextField
                                className='explore_meals_filter_number'

                                label={'Max protein'}
                                type="number"
                                value={selected_prot[1]}
                                onChange={
                                    (e) => {
                                        updateNumberFields(selected_prot, setSelectedProt, e.target.value, 1)

                                    }
                                }
                                margin="none"
                                sx={numberFieldSX}
                            />
                        </div>
                    </div>
                    {/* Carb */}
                    <div className='explore_meals_filter_sections'>

                        <p className='font_family_inter font_size_16 gray_scale_2'>
                            Carb
                        </p>
                        <div className='explore_meals_numbers'>
                            <TextField
                                className='explore_meals_filter_number'

                                label={'Min carb'}
                                type="number"
                                value={selected_carb[0]}
                                onChange={
                                    (e) => {
                                        updateNumberFields(selected_carb, setSelectedCarb, e.target.value, 0)
                                    }
                                }
                                margin="none"
                                sx={numberFieldSX}
                            />
                            -
                            <TextField
                                className='explore_meals_filter_number'

                                label={'Max carb'}
                                type="number"
                                value={selected_carb[1]}
                                onChange={
                                    (e) => {
                                        updateNumberFields(selected_carb, setSelectedCarb, e.target.value, 1)
                                    }
                                }
                                margin="none"
                                sx={numberFieldSX}
                            />
                        </div>
                    </div>
                    {/* Fat */}
                    <div className='explore_meals_filter_sections'>

                        <p className='font_family_inter font_size_16 gray_scale_2'>
                            Fat
                        </p>
                        <div className='explore_meals_numbers'>
                            <TextField
                                className='explore_meals_filter_number'
                                label={'Min fat'}
                                type="number"
                                value={selected_fat[0]}
                                onChange={
                                    (e) => {
                                        updateNumberFields(selected_fat, setSelectedFat, e.target.value, 0)
                                    }
                                }
                                margin="none"
                                sx={numberFieldSX}
                            />
                            -
                            <TextField
                                className='explore_meals_filter_number'
                                label={'Max fat'}
                                type="number"
                                value={selected_fat[1]}
                                onChange={
                                    (e) => {
                                        updateNumberFields(selected_fat, setSelectedFat, e.target.value, 1)
                                    }
                                }
                                margin="none"
                                sx={numberFieldSX}
                            />
                        </div>
                    </div>
                    {/* Cost */}
                    <div className='explore_meals_filter_sections'>

                        <p className='font_family_inter font_size_16 gray_scale_2'>
                            Cost
                        </p>
                        <div className='explore_meals_numbers'>
                            <TextField
                                className='explore_meals_filter_number'
                                label={'Min cost'}
                                type="number"
                                value={selected_cost[0]}
                                onChange={
                                    (e) => {
                                        updateNumberFields(selected_cost, setSelectedCost, e.target.value, 0)
                                    }
                                }
                                margin="none"
                                sx={numberFieldSX}
                            />
                            -
                            <TextField
                                className='explore_meals_filter_number'
                                label={'Max cost'}
                                type="number"
                                value={selected_cost[1]}
                                onChange={
                                    (e) => {
                                        updateNumberFields(selected_cost, setSelectedCost, e.target.value, 1)

                                    }
                                }
                                margin="none"
                                sx={numberFieldSX}
                            />
                        </div>
                    </div>
                    <hr style={{ width: '100%' }} />
                    <div className='explore_meals_selects'>

                        {/* Cuisine */}
                        <FormControl className='explore_meals_filter_select'>
                            <InputLabel
                                sx={{

                                    '&.Mui-focused': {
                                        color: '#1F2933', // Color when the input is focused
                                    },
                                }}
                            >{'Cusines'}</InputLabel>

                            <Select
                                label={'Cuisines'}
                                value={selected_cuisine}
                                onChange={(e) => {
                                    if (e.target.value !== undefined) {
                                        setSelectedCuisines(e.target.value)
                                    }
                                }}
                                sx={selectSX}
                            >
                                <MenuItem value={''}>{'All'}</MenuItem>

                                {
                                    allCuisines.map((cuisine) => (
                                        <MenuItem value={cuisine.cuisine_id}>{cuisine.name}</MenuItem>
                                    ))
                                }

                            </Select>
                        </FormControl>
                        <hr />
                        {/* Course */}

                        <FormControl className='explore_meals_filter_select' >
                            <InputLabel
                                sx={{

                                    '&.Mui-focused': {
                                        color: '#1F2933', // Color when the input is focused
                                    },
                                }}
                            >{'Courses'}</InputLabel>

                            <Select
                                label={'Courses'}
                                value={selected_course}
                                onChange={(e) => {
                                    setSelectedCourse(e.target.value)
                                }}
                                sx={selectSX}
                            >
                                <MenuItem value={''}>{'All'}</MenuItem>

                                {

                                    allCourses.map((c) => (
                                        <MenuItem value={c.course_id}>{c.name}</MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>

                    </div>
                    <hr style={{ width: '100%' }} />
                    <div className='explore_meals_filter_buttons'>

                        <div className='font_family_inter font_size_14 font_weight_600 white explore_meals_filter_apply_button green_orange_gradient'
                            onClick={() => {
                                setShowFilter(false)
                            }}>
                            Cancel
                        </div>
                        <div className='font_family_inter font_size_14 font_weight_600 white green_gradient explore_meals_filter_apply_button'
                            onClick={() => {
                                updateObjectFromState()
                                setShowFilter(false)

                            }}
                        >
                            Apply

                        </div>
                    </div>

                </div>
            }
            <div className='add_meal_search_box_parent'>
                <input className='add_meal_search_box font_family_inter font_size_14'
                    placeholder="Search..."
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />
            </div>

            <div className='explore_meals_top_buttons'>

                <div className={(selectedPremadeList == 'see_all' ? 'explore_meals_top_button_selected' : 'explore_meals_top_button')} onClick={() => {
                    setSelectedPremadeList('see_all')
                    premadeGroupChanged(allMeals)
                }}>
                    <p className={selectedPremadeList == 'see_all' ? 'font_size_12 green_gradient_p font_weight_600' : 'font_size_12 gray_scale_2 font_weight_400'}>
                        See All
                    </p>
                </div>
                <div className={(selectedPremadeList == 'trending_meals' ? 'explore_meals_top_button_selected' : 'explore_meals_top_button')} onClick={() => {
                    setSelectedPremadeList('trending_meals')
                    premadeGroupChanged(tredningMeals)
                }}>
                    <p className={selectedPremadeList == 'trending_meals' ? 'font_size_12 green_gradient_p font_weight_600' : 'font_size_12 gray_scale_2 font_weight_400'}>

                        Trending Meals
                    </p>
                </div>
                <div className={(selectedPremadeList == 'everyones_favorite' ? 'explore_meals_top_button_selected' : 'explore_meals_top_button')} onClick={() => {
                    setSelectedPremadeList('everyones_favorite')
                    premadeGroupChanged(favoriteMeals)
                }}>
                    <p className={selectedPremadeList == 'everyones_favorite' ? 'font_size_12 green_gradient_p font_weight_600' : 'font_size_12 gray_scale_2 font_weight_400'}>
                        Everyone's Favorite
                    </p>
                </div>
                <div className={(selectedPremadeList == 'picked_for_you' ? 'explore_meals_top_button_selected' : 'explore_meals_top_button')} onClick={() => {
                    setSelectedPremadeList('picked_for_you')
                    premadeGroupChanged(pickedForYouMeals)

                }}>
                    <p className={selectedPremadeList == 'picked_for_you' ? 'font_size_12 green_gradient_p font_weight_600' : 'font_size_12 gray_scale_2 font_weight_400'}>
                        Picked For You
                    </p>
                </div>
            </div>
            {
                !noResults && <div className='explore_meals_meals_list'>
                    {mealsToShow.map((meal) => {
                        return <MealCard item={meal} key={meal.meal_id} />
                    })}
                </div>
            }

            {
                noResults && <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }} className='font_family_inter font_size_18 font_weight_600 green_1'>
                    No Meal Found
                </div>
            }

            {
                selectedPremadeList == 'see_all' && (query == null || query == '') && <div style={{
                    display: 'flex', justifyContent: 'center', paddingTop: '24px'
                }}>

                    < div className='flex justify_center gap_20 gray_scale_1 align_center' >


                        <BeanButtonPrev onClick={() => {
                            pageNum != 1 ? setPageNum(pageNum - 1) : setPageNum(pageNum)
                        }} />

                        <span style={{ userSelect: 'none' }}>{`${pageNum}/${total_pages}`}</span>

                        <BeanButtonNext onClick={() => {
                            pageNum != (total_pages) ? setPageNum(pageNum + 1) : setPageNum(pageNum)
                        }} />


                    </div>
                </div >
            }
            <br />
        </div >
    );
}

export default ExploreMeals;
